module.exports = __webpack_public_path__ + "images/emoji/arrow_down_small.2db0f910037cf221d17e.png";